<template>
  <div style="padding: 10px">
    <el-button
      style="margin-bottom: 10px"
      type="primary"
      @click="openEditAdminUserDialog(true)"
      >添加账号</el-button
    >

    <el-table :data="userList" border size="small" style="width: 700px">
      <el-table-column
        prop="username"
        label="用户名"
        align="center"
        width="150"
      ></el-table-column>
      <el-table-column
        prop="remark"
        label="备注"
        align="center"
        width="250"
      ></el-table-column>      
      <el-table-column label="被禁用" align="center" width="100">
        <template scope="scope">
          <span
            v-if="scope.row.isBanned"
            class="ban-status-tag ban-status-tag-yes"
            >是</span
          >
          <span v-else class="ban-status-tag">否</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="200">
        <template scope="scope">
          <div v-if="scope.row.username != getLoginUsername()">
            <el-button
              type="danger"
              round
              size="mini"
              @click="banUser(scope.row.username)"
              >禁用</el-button
            >
            <el-button
              type="primary"
              round
              size="mini"
              @click="resetPassword(scope.row.username)"
              >重置密码</el-button
            >
          </div>
        </template>
      </el-table-column>
    </el-table>

    <!-- “编辑账号”对话框 -->
    <EditAdminUserDialog
      v-if="shouldEditAdminUserDialogVisible"
      @close="onEditAdminUserDialogClosed()"
      :value="valueForEditAdminUserDialog"
    ></EditAdminUserDialog>
  </div>
</template>

<script>
const axios = require("axios");
import util from "@/util";
import bizutil from "@/bizutil";

import EditAdminUserDialog from "./EditAdminUserDialog";

export default {
  data() {
    return {
      shouldEditAdminUserDialogVisible: false, // “添加账号”对话框是否应该显示出来
      valueForEditAdminUserDialog: null, // 要传递给“编辑账号”对话框的数据
      userList: [], // 账号列表里展示的数据
    };
  },

  created() {
    // 拉取账号集合
    this.loadUserList();
  },

  components: {
    EditAdminUserDialog,
  },

  methods: {
    /**
     * 查询账号集合
     */
    async loadUserList() {
      let resData = (
        await axios.post(
          `${util.getBackendApiBase()}/api/admin/v1/account/getList`,
          {},
          {
            headers: {
              token: bizutil.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        // 可能需要重新登录
        if (resData.code == 2004) {
          util.gotoLoginPage();
          return;
        }

        this.$message.error(resData.message);
        return;
      }

      let listInResponse = resData.data.users || [];

      let list = [];
      for (let e of listInResponse) {
        list.push({
          username: e.username,
          remark: e.remark,
          createdAt: e.createdAt,
          isBanned: e.isBanned,
        });
      }

      // 排序（先按是否被禁用排序，再按用户名排序）
      list.sort((x, y) => {
        if (!x.isBanned && y.isBanned) {
          return -1;
        } else if (x.isBanned && !y.isBanned) {
          return 1;
        } else {
          if (x.username == y.username) {
            return 0;
          } else {
            return x.username < y.username ? -1 : 1;
          }
        }
      });      

      this.userList = list;
    },

    /**
     * 禁用一个账号
     * @param {*} username
     */
    async banUser(username) {
      try {
        // 弹确认框
        await this.$confirm(`确认禁用账号“${username}”？`);

        let resData = (
          await axios.post(
            `${util.getBackendApiBase()}/api/admin/v1/account/ban`,
            {
              username: username,
            },
            {
              headers: {
                token: bizutil.getLoginUserToken(),
              },
            }
          )
        ).data;
        if (resData.code > 0) {
          // 可能需要重新登录
          if (resData.code == 2004) {
            util.gotoLoginPage();
            return;
          }

          this.$message.error(resData.message);
          return;
        }

        this.$message({
          message: "操作成功",
          type: "success",
        });

        for (let i = 0; i < this.userList.length; i++) {
          if (this.userList[i].username == username) {
            this.userList[i].isBanned = true;
          }
        }
      } catch (e) {}
    },

    /**
     * 重置密码
     * @param {*} username
     */
    async resetPassword(username) {
      try {
        // 弹确认框
        await this.$confirm(`确认为账号“${username}”重置密码？`);

        let resData = (
          await axios.post(
            `${util.getBackendApiBase()}/api/admin/v1/account/resetPassword`,
            {
              username: username,
            },
            {
              headers: {
                token: bizutil.getLoginUserToken(),
              },
            }
          )
        ).data;
        if (resData.code > 0) {
          // 可能需要重新登录
          if (resData.code == 2004) {
            util.gotoLoginPage();
            return;
          }

          this.$message.error(resData.message);
          return;
        }

        // 弹窗展示新密码
        this.$alert(
          `账号${username}的新密码（请务必记下来）：${resData.data.newPassword}`,
          "操作成功",
          {
            confirmButtonText: "已记下",
            center: true,
          }
        );
      } catch (e) {}
    },

    /**
     * 打开“编辑账号”对话框
     */
    async openEditAdminUserDialog(isCreate, oldData) {
      this.shouldEditAdminUserDialogVisible = true;
      this.valueForEditAdminUserDialog = {
        isCreate: isCreate,
        oldData: oldData,
      };
    },

    /**
     * “编辑账号”对话框关闭了
     */
    async onEditAdminUserDialogClosed() {
      this.shouldEditAdminUserDialogVisible = false;

      // 重新拉取账号集合
      return this.loadUserList();
    },

    /**
     * 取得当前登录用户的用户名
     */
    getLoginUsername() {
      let loginUser = util.getFromLocalStorage("loginUser");
      if (loginUser) {
        return loginUser.username;
      } else {
        return "";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.ban-status-tag {
  display: inline-block;
  padding: 0 10px;
  border: 1px solid #d9ecff;
  border-radius: 4px;
}
.ban-status-tag-yes {
  background-color: lightgray;
  border-color: lightgray;
}
</style>